import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import { formatNumber, transformDate } from '../../../services/Local-services';
// Assets
import Hooli from '../../../assets/icons/hooli.svg';
import HooliCoins from "../../../assets/icons/hc.svg";
import Credito from '../../../assets/icons/credito.svg';
import ArrowDown from '../../../assets/icons/arrow-down-red.svg';
import ArrowDownWhite from '../../../assets/icons/arrow-down-white.svg';
// Styles
import classes from './Card.module.scss';
// Skeleton
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// Charts
import { Chart, LineElement, Legend, Title, CategoryScale, LinearScale, PointElement, Tooltip } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Close } from '@mui/icons-material';

Chart.register(LineElement, Legend, Title, CategoryScale, LinearScale, PointElement, Tooltip);

export default function Card({ type, dataHoy, dataSerie, totales, link, title, image, position, cargando, ultimoMovimiento, detail }) {
    const [open, setOpen] = useState(false);
    const [chart, setChart] = useState('ventas');
    
    const handleClick = (newChart) => () => {
        setChart(newChart);
        if (open && chart === newChart) return setOpen(false);
        setOpen(true);
    };

    const chartOptions = {
        responsive: true,
        // maintainAspectRatio: false,
        tension: 0.2,
        events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
        plugins: {
            legend: {
                position: 'bottom',
            },
            // tooltip: {
            //     enabled: true,
            //     callbacks: {
            //         label: function(context) {
            //             return <div>Hola</div>;
            //         },
            //         title: function(tooltipItems) {
            //             return <div>Holas</div>;
            //         }
            //     }
            // }
        },
        scales: {
            y: {
                ticks: {
                    maxTicksLimit: 13,
                    stepSize: 1
                }
            },
  }
    };
    return (
        <>
        <div className={`${classes.card} ${classes[title.toLowerCase()]}`} style={position}>
            <div className={classes.titleContainer}>
                <img className={classes.icon} src={image} alt={title} />
                <h4 className={classes.title}>{title}</h4>
                {detail ? <p className={classes.detail}>{detail}</p> : ""}
            </div>
            <div className={classes.bodyContainer}>
                <div className={classes.row}>
                <div className={classes.total}>
                    <p>Total</p>
                    <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.dataTotal ? '$' + formatNumber(totales?.dataTotal) : "$0,00"}</h4>
                    <div className={classes.divider}></div>
                    <div className={classes.horizontalDivider}>-</div>
                    <p>Operaciones</p>
                    <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.cantidadTotal || 0}</h4>
                </div>
                <div className={classes.right}>
                <div className={`${classes.parcial} ${classes.hooli}`}>
                    <img src={Hooli} alt="Hooli" />
                    <div className={classes.ventas}>
                        <p>{type === "ventas" ? "Billetera" : "Pesos"}</p>
                        <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.montoTotalArs ? '$' + formatNumber(totales?.montoTotalArs) : "$0,00"}</h4>
                        <div className={`${classes.operaciones} ${classes.blue}`}>
                            <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.cantidadArs || 0}</h4>
                            <p>Operaciones</p>
                        </div>
                    </div>
                </div>
                <div className={`${classes.parcial} ${classes.credito}`}>
                    <img src={HooliCoins} alt="Credito" />
                    <div className={classes.ventas}>
                        <p>Créditos</p>
                        <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.montoCreditos ? '$' + formatNumber(totales?.montoCreditos) : "$0,00"}</h4>
                        <div className={`${classes.operaciones} ${classes.purple}`}>
                            <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.cantidadCreditos || "0"}</h4>
                            <p>Operaciones</p>
                        </div>
                    </div>
                </div>
                {type === "ventas" && <><div className={`${classes.parcial} ${classes.tarjetaDebito}`}>
                    <img src={Credito} alt="Credito" />
                    <div className={classes.ventas}>
                        <p>Tarjeta Débito</p>
                        <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.montoDebito ? '$' + formatNumber(totales?.montoDebito) : "$0,00"}</h4>
                        <div className={`${classes.operaciones} ${classes.purple}`}>
                            <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.cantidadDebito || "0"}</h4>
                            <p>Operaciones</p>
                        </div>
                    </div>
                </div>
                <div className={`${classes.parcial} ${classes.tarjetaCredito}`}>
                    <img src={Credito} alt="Credito" />
                    <div className={classes.ventas}>
                        <p>Tarjeta Crédito</p>
                        <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.montoCredito ? '$' + formatNumber(totales?.montoCredito) : "$0,00"}</h4>
                        <div className={`${classes.operaciones} ${classes.blue}`}>
                            <h4>{cargando ? <Skeleton count={1} enableAnimation={true} direction='ltr' /> : totales?.cantidadCredito || 0}</h4>
                            <p>Operaciones</p>
                        </div>
                    </div>
                </div></>}
                </div>
                </div>
                <div className={classes.buttonsContainer}>
                    <button disabled={cargando}>
                        <Link to={link}>Ver detalle</Link>
                    </button>
                    <button disabled={cargando} onClick={handleClick('ventas')} className={open && chart === 'ventas' ? classes.selected : ''}>
                        <span>Ver gráfico de montos</span>
                        <img src={open && chart === 'ventas' ? ArrowDownWhite : ArrowDown} />
                    </button>
                    <button disabled={cargando} onClick={handleClick('operaciones')} className={open && chart === 'operaciones' ? classes.selected : ''}>
                        <span>Ver gráfico de operaciones</span>
                        <img src={open && chart === 'operaciones' ? ArrowDownWhite : ArrowDown} />
                    </button>
                </div>
            </div>
        </div>
                {open && chart === 'ventas' &&
                    <div className={classes.containerCharts} >
                        <div className={classes.charts}>
                            <div className={classes.header}>
                                <h3>
                                    Montos
                                </h3>
                            </div>
                            <Close
                                className={`${classes.closeButton} ${classes.white}`}
                                onClick={() => setOpen(false)}
                                role="button"
                            />
                            <Line options={chartOptions} data={getChartData(dataSerie.filter(item => item.posTransaccionMetodoPago === "H" || item.posTransaccionMetodoPago === "C" || item.posTransaccionMetodoPago === "D" || item.posTransaccionMetodoPago === "B"), 'posTransaccionMontoTotal')} />
                        </div>
                    </div>
                }
                {open && chart === 'operaciones' &&
                    <div className={classes.containerCharts} >
                        <div className={classes.charts}>
                            <div className={classes.header}>
                                <h3>
                                    Operaciones
                                </h3>
                            </div>
                            <Close
                                className={`${classes.closeButton} ${classes.white}`}
                                onClick={() => setOpen(false)}
                                role="button"
                            />
                            <Line options={chartOptions} data={getChartData(dataSerie.filter(item => item.posTransaccionMetodoPago === "H" || item.posTransaccionMetodoPago === "C" || item.posTransaccionMetodoPago === "D" || item.posTransaccionMetodoPago === "B"), 'posTransaccionOperaciones')} />
                        </div>
                    </div>
                }
        </>
    )
};

const getChartData = (data, key) => {
    function agruparPorFechaYSumar(data) {
    const agrupado = data.reduce((acc, item) => {
    const fecha = item.posTransaccionFecha;

    if (!acc[fecha]) {
        acc[fecha] = {
            posTransaccionFecha: fecha,
            posTransaccionMontoTotal: 0,
            posTransaccionOperaciones: 0,
        };
    }

    acc[fecha].posTransaccionMontoTotal += item.posTransaccionMontoTotal;
    acc[fecha].posTransaccionOperaciones += item.posTransaccionOperaciones;

    return acc;
    }, {});
  return Object.values(agrupado);
}
    return {
        labels: agruparPorFechaYSumar(data).map(item => moment(item.posTransaccionFecha).locale('es').format('DD/MM/YY')),
        datasets: [
            {
                label: 'Total',
                data: agruparPorFechaYSumar(data).map(item => item[key]),
                borderColor: 'rgb(229, 109, 161)',
                backgroundColor: 'rgba(229, 109, 161, 0.5)',
            },
            {
                label: 'Pesos',
                data: Object.values(data).filter(item => item.posTransaccionMetodoPago === "H").map(item => item[key]),
                borderColor: 'rgb(85, 103, 174)',
                backgroundColor: 'rgba(85, 103, 174, 0.5)',
            },
            {
                label: 'Tarjeta Crédito',
                data: Object.values(data).filter(item => item.posTransaccionMetodoPago === "C").map(item => item[key]),
                borderColor: 'rgb(99, 209, 162)',
                backgroundColor: 'rgba(99, 209, 162, 0.5)',
            },
            {
                label: 'Tarjeta Débito',
                data: Object.values(data).filter(item => item.posTransaccionMetodoPago === "D").map(item => item[key]),
                borderColor: 'rgb(147, 115, 177)',
                backgroundColor: 'rgba(147, 115, 177, 0.5)',
            },
            {
                label: 'Creditos',
                data: Object.values(data).filter(item => item.posTransaccionMetodoPago === "B").map(item => item[key]),
                borderColor: 'rgb(99, 195, 209)',
                backgroundColor: 'rgba(99, 195, 209, 0.5)',
            }
        ],
    };
}